<lib-reactive-form-group
  #form
  [bindTo]="req"
  [applyDisabledStylesToAllElements]="true"
  [includeIconWithError]="true"
  (formSubmitted$)="formSubmitted($event)"
  (formChanged$)="formChanged($event)">
  <lib-reactive-form-column-layout [nColumns]="(isMobile$ | async) ? 1 : 2" [columnGap]="'2rem'">
    <lib-reactive-form-birthday
      [inputName]="'birthdate'"
      label="Date of Birth"
      i18n-label
      [bindingProperty]="'birthdate'"
      [programmaticallyChangeValue]="programmaticBirthdate"
      [required]="true"
      hintText="DD / MM / YYYY"
      i18n-hintText />
    <lib-reactive-form-sin-input
      [inputName]="'socialInsuranceNumber'"
      [required]="canViewFullSIN"
      [disabled]="!canViewFullSIN"
      label="Social Insurance Number"
      i18n-label
      [programmaticallyChangeValue]="programmaticSIN"
      [bindingProperty]="'socialInsuranceNumber'" />
  </lib-reactive-form-column-layout>
  <lib-reactive-form-column-layout [nColumns]="(isMobile$ | async) ? 1 : 2" [columnGap]="'2rem'">
    <lib-reactive-form-drop-down
      [inputName]="'genderId'"
      [required]="true"
      label="Gender at Birth"
      i18n-label
      [inlineLabel]="false"
      [dropdowns]="(genderDropdowns$ | async) ?? undefined"
      [bindingProperty]="'genderId'" />
    <lib-reactive-form-drop-down
      [inputName]="'pronounId'"
      label="Preferred Pronouns"
      hintText="Optional"
      i18n-hintText
      i18n-label
      [inlineLabel]="false"
      [clearable]="true"
      [dropdowns]="(pronounDropdowns$ | async) ?? undefined"
      [bindingProperty]="'pronounId'" />
  </lib-reactive-form-column-layout>
  <hr class="divider" />
  <ng-content></ng-content>
  <lib-reactive-form-file-uploader
    #fileUploader
    (previewClicked)="MediaUtils.openFileInNewTab($event)"
    (duplicateFileNamesAdded)="duplicateFilesAdded()"
    [inputName]="'file'"
    [id]="'file'"
    [disabled]="!(infoChanged$ | async) ?? false"
    [showSelectedFileIcon]="true"
    label="Document"
    uploadTitle="Upload a file"
    previewLabel="Preview"
    removeLabel="Remove"
    chooseAnotherLabel="Add Another File"
    uploadBody="or drag and drop a .png, .jpeg or .pdf up to 3MB"
    [accept]="acceptedFileTypes"
    i18n-label
    i18n-uploadTitle
    i18n-previewLabel
    i18n-removeLabel
    i18n-chooseAnotherLabel
    i18n-uploadBody
    [showPreview]="true"
    [multiple]="true"
    [maxFileSizeInMb]="3"
    [maxTotalFileSizeInMb]="3"
    [maxFiles]="5"
    [chooseAnother]="true"
    [required]="!!(infoChanged$ | async)" />
  <hr class="mb-3" />
</lib-reactive-form-group>
